<template>
  <div class="search-form">
    <b-row align-h="start">
      <b-col cols="8">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="'合同号/编辑柜号/集装箱号/箱封号/海关HSCODE/商品名称 搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>

            <el-button
              v-if="shipmentStatus == 'C'"
              size="mini"
              type="primary"
              class="ml-2"
              icon="el-icon-refresh"
              plain
              :loading="buildHsDataLoading"
              @click="buildHsData"
              >{{
                $l('INDEX.form_label_buildHsData') || '生成报关/清关数据'
              }}</el-button
            >
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: ''
}
export default {
  props: {
    shipmentCode: { type: String, deafult: '' },
    shipmentStatus: { type: String }
  },
  data() {
    return {
      form: { ...initForm },
      buildHsDataLoading: false
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    buildHsData() {
      if (this.shipmentCode) {
        this.buildHsDataLoading = true
        this.$api
          .shipmetBuildHsData({ shipmentCode: this.shipmentCode })
          .then((res) => {
            const { status } = res
            this.buildHsDataLoading = false
            this.$message({
              message:
                status === 200
                  ? this.$l('INDEX.tips_success') || '数据生成成功'
                  : this.$l('INDEX.tips_error') || '数据生成失败',
              type: status === 200 ? 'success' : 'error'
            })
          })
          .catch(() => {
            this.buildHsDataLoading = false
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
</style>
